import React from "react";
import "./style.css";
import { FaFacebook, FaInstagramSquare } from "react-icons/fa";
import { FaSquareYoutube } from "react-icons/fa6";
import paduka from "../../../../assets/footerimages/paduka.jpeg"


export default function Footer() {
  return (
    <footer>
      <div className="footer-container">
        {/* Left side - Image */}
        <div className="footer-image">
          <img src={paduka} alt="Logo" />
        </div>

        {/* Center - Contact Info */}
        <div className="footer-content">
          <h3>Contact Us</h3>
          <p style={{ textTransform: "lowercase" }}>support@dattamandir.com</p>
          <p>9422070407</p>
          <p>श्री दत्त मंदिर संस्थान रुईभर धाराशिव, 413501</p>
        </div>

        {/* Right - Quick Links */}
        <div className="footer-content">
          <h3>Quick Links</h3>
          <ul className="list">
            <li><a href="/">मुख्य पृष्ठ</a></li>
            {/* <li><a href="#">About</a></li> */}
            <li><a href="/babaji">बाबाजी</a></li>
            <li><a href="/donation">देणगी</a></li>
            <li>
              <a href="/dharmik-sankalpana">धार्मिक संकल्प</a>
            </li>
            <li><a href="/pranpratisthapana">प्राणप्रतिष्टा</a></li>
            <li><a href="/contact-us">संपर्क</a></li>
          </ul>
        </div>

        {/* Rightmost - Social Icons */}
        <div className="footer-content">
          <h3>Follow Us</h3>
          <ul className="social-icons">
            <li>
              <a href="https://www.facebook.com/DattamandirRuibhar/" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/@ShrishetraDattaMandirRuibhar" target="_blank" rel="noopener noreferrer">
                <FaSquareYoutube />
              </a>
            </li>
          </ul>
        </div>

      </div>

      <div className="bottom-bar">
        <p>&copy; {new Date().getFullYear()} श्री दत्त मंदिर संस्थान रुईभर.</p>
      </div>
    </footer>
  );
}
